module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-footer-consumer-78ef9a0c66e13bf083071a4b8abadccd.png";